<ion-col size="12">
  <form [formGroup]="form1">
    <table>
      <thead>
        <tr>
          <th class="field-labels"></th>
          <th class="field-labels">Sort</th>
          @for (
            day of [
              "Sunday",
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
            ];
            track day
          ) {
            <th colspan="3" class="field-labels">{{ day }}</th>
          }
        </tr>
        <tr>
          <th></th>
          <th></th>
          @for (
            day of [
              "Sunday",
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
            ];
            track day
          ) {
            <th>Start</th>
            <th>End</th>
            <th>Offset</th>
          }
        </tr>
      </thead>

      <tbody>
        @for (row of TABLE_DATA; track row) {
          <tr>
            <td>{{ row[0].label }}</td>
            <td>
              <ion-checkbox
                (ionChange)="onCheckboxToggle($event.detail.checked, row)"
              ></ion-checkbox>
            </td>

            @for (cell of row.slice(1); track cell) {
              <td>
                <input
                  class="start-time-field"
                  type="text"
                  [formControl]="getFormControl(cell.formControlStart)"
                  maxlength="5"
                  placeholder="HH:MM"
                  (keypress)="onKeyPress($event)"
                />
              </td>
              <td>
                <input
                  class="end-time-field"
                  type="text"
                  [formControl]="getFormControl(cell.formControlEnd)"
                  maxlength="5"
                  placeholder="HH:MM"
                  (keypress)="onKeyPress($event)"
                />
              </td>
              <td>
                <ng-select
                  class="offset-field"
                  [items]="OFFSET_OPTIONS"
                  bindLabel="label"
                  bindValue="value"
                  [formControl]="getFormControl(cell.formControlOffset)"
                  [clearable]="false"
                  [searchable]="false"
                ></ng-select>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </form>
</ion-col>
